import { styled } from 'baseui';

export const ModalHeader = styled('div', ({ $theme }: any) => {
  return {
    ...$theme.typography.HeadingXSmall,
    color: $theme.colors.white,
    padding: `${$theme.sizing.scale550} ${$theme.sizing.scale600}`,
    background: $theme.colors.backgroundPrimary,
    border: $theme.borders.border100,
    borderTopLeftRadius: $theme.borders.radius300,
    borderTopRightRadius: $theme.borders.radius300,
  };
});

export const ModalBody = styled('div', ({ $theme }: any) => ({
  ...$theme.typography.ParagraphSmall,
  flexGrow: 2,
  backgroundColor: $theme.colors.backgroundSecondary,
  color: $theme.colors.contentSecondary,
  paddingTop: $theme.sizing.scale600,
  paddingLeft: $theme.sizing.scale800,
  paddingRight: $theme.sizing.scale800,
  paddingBottom: $theme.sizing.scale700,
}));

export const ModalFooter = styled('div', ({ $theme }: any) => ({
  ...$theme.typography.ParagraphSmall,
  marginTop: '0px',
  paddingLeft: $theme.sizing.scale800,
  paddingRight: $theme.sizing.scale800,
  marginBottom: '0px',
  paddingTop: $theme.sizing.scale500,
  paddingBottom: $theme.sizing.scale800,
  backgroundColor: $theme.colors.backgroundInverseSecondary,
  textAlign: 'center',
}));
